





























import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/crm-visit-planning';
import { getServerISODate } from '@/services/utils';
import Component from 'vue-class-component';

@Component({
  components: {}
})
export default class VisitPlanningCycle extends BaseComponent {
  cycle = null;

  today = null;

  mounted() {
    this.loadVisitPlanningUserCycle();
    getServerISODate().subscribe((res) => {
      this.today = res;
    });
  }

  loadVisitPlanningUserCycle() {
    service.getCrmVisitPlanningUserCycle().subscribe(
      (res) => {
        this.cycle = res;
        this.$emit('cycleLoaded', res);
      },
      (error) => {
        this.showToastApiError(error);
        this.$emit('cycleLoaded', null);
      }
    );
  }
}
